import { render, staticRenderFns } from "./openingView.vue?vue&type=template&id=0b098d10&"
import script from "./openingView.vue?vue&type=script&lang=js&"
export * from "./openingView.vue?vue&type=script&lang=js&"
import style0 from "./openingView.vue?vue&type=style&index=0&id=0b098d10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports